<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('notifications.title') }}</div>
            <div class="col-md-6 text-right">
              <router-link
                :to="{name: 'notification_settings'}"
                :title="$t('notifications.config')"
                class="btn btn-sm btn-outline-info"
              >
                <i class="icon-settings"></i> {{ $t('notifications.config') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div id="accordion">
            <emailtemplate
              api_key="TENDER_FINISHED"
              num="One"
              :title="$t('notifications.tender-finished')"
              tags="{tender_code}, {tender_start}, {tender_finish}"
              type="INTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="NEW_SUPPLIER"
              num="Two"
              :title="$t('notifications.new-supplier')"
              tags="{company_name}, {company_registration_code}, {user_first_name}, {user_last_name}, {user_personal_code}, {user_email}, {user_phone}"
              type="INTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="ACCOUNT_ACTIVATED"
              num="Four"
              :title="$t('notifications.account-activated')"
              tags="{user_first_name}, {user_last_name}"
              type="INTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="TENDER_OPENED"
              num="Five"
              :title="$t('notifications.tender-opened')"
              tags="{tender_code}, {tender_finish}, {details_list}, {tender_group_name}, {tender_warehouse_name}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="TENDER_FINISHED"
              num="Six"
              :title="$t('notifications.tender-finished')"
              tags="{tender_code}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="TENDER_WINNER"
              num="Seven"
              :title="$t('notifications.tender-winner')"
              tags="{tender_code}, {advanced_details_list}, {tender_group_name}, {tender_warehouse_name}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="TENDER_MEMBER"
              num="Eight"
              :title="$t('notifications.tender-member')"
              tags="{tender_code}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="ACCOUNT_REGISTERED"
              num="Nine"
              :title="$t('notifications.account-registered')"
              tags="{user_first_name}, {user_last_name}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="ACCOUNT_ACTIVATED"
              num="Ten"
              :title="$t('notifications.account-activated')"
              tags="{user_first_name}, {user_last_name}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="ACCOUNT_DEACTIVATED"
              num="Eleven"
              :title="$t('notifications.account-deactivated')"
              tags="{user_first_name}, {user_last_name}"
              type="EXTERNAL">
            </emailtemplate>
            <emailtemplate
              api_key="PASSWORD_RECOVERY"
              num="Twelve"
              :title="$t('notifications.password-recovery')"
              tags="-"
              type="EXTERNAL">
            </emailtemplate>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Emailtemplate from '@/components/Emailtemplate.vue'

export default {
  components: {
    emailtemplate: Emailtemplate
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'notifications'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Notifications.vue